import { VNode } from 'vue';
import { DirectiveBinding } from 'vue/types/options';
import { AnalyticsEvent } from '../models';

export class InternalCampaignEvent implements AnalyticsEvent {
    name = 'InternalCampaignEvent';
    constructor(public readonly campaign: string) { }
}